import { Chip } from '@frameio/vapor';
import TEXT from './generated/TEXT/BetaBadge';

TEXT.DEFINE({
  /** Label indicating the feature is in beta */
  betaLabel: 'Beta',
});

export const BetaBadge = ({ isActive = true }: { isActive?: boolean }) => (
  <Chip color={isActive ? 'green' : 'default'} variant="ghost">
    {TEXT.betaLabel}
  </Chip>
);
